import tukasLogo from '@/images/clients/tukas.svg'
import { Market } from 'BrokerTsLib/src/enums'
import type { IPartnerSettings } from '.'

export const TUkas: IPartnerSettings = {
  partner: 'TUkas',
  hosts: [
    'srovnavac.tukas.cz'
    //, 'localhost:44470'
  ],
  logo: tukasLogo,
  market: Market.CZ
}
